<template>
  <div class="accordion">
    <div class="header" v-on:click="toggle">
      <div class="title">
        {{ title }} <span class="text-sm text-gray-500 normal-case">{{ titleCode }}</span>
      </div>
      <svg xmlns="http://www.w3.org/2000/svg" :class="{ rotate: show }" width="14" height="10" role="presentation"><path d="M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"></path></svg>
    </div>

    <div class="body" :class="{ collapsed: !show, 'large-height': largeHeight }">
      <div class="body-inner" v-if="show">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    titleCode: {
      type: String
    },
    open: {
      type: Boolean,
      default: false
    },
    largeHeight: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      show: this.open
    };
  },
  methods: {
    toggle () {
      this.show = !this.show;
    }
  }
};
</script>

<style lang="postcss" scoped>
.accordion {
  @apply mb-3 mt-1;
}

.accordion .header {
  @apply font-bold rounded-sm font-eurostile bg-gray-300 px-3 py-2 relative;
  cursor: pointer;
}

.accordion svg {
  position: absolute;
  top: 0.9rem;
  right: 0.75rem;
  transform: rotate(0deg);
  transition-duration: 0.3s;
  fill: theme('colors.gray.700');
}

.accordion .body {
  @apply duration-500 transition-all overflow-hidden border border-t-0 rounded-sm bg-gray-200;
  max-height: 2000px;

  &.collapsed {
    max-height: 0;
    overflow: hidden;
  }

  &.large-height {
    max-height: 9000px;
  }
}

.accordion .body-inner {
  @apply px-1 pb-5;

  @screen lg {
    @apply px-2;
  }
}

.accordion svg.rotate {
  transform: rotate(180deg);
  transition-duration: 0.3s;
}
</style>
